import { memo, useContext } from 'react';
import ContentData from './ContentData';
import ContentInformation from './ContentInformation';
import ContentMap from './ContentMap';
import { InterfaceContext } from '../model/InterfaceProvider';
import DownloadModal, { DownloadModalBackground } from './DownloadModal';
import AppDownloader from '../controller/AppDownloader';

const tabs = [
    { id: 'map', obj: <ContentMap /> },
    { id: 'data', obj: <ContentData /> },
    { id: 'info', obj: <ContentInformation /> }
];

const TabsContent = () => {
    //if downloading display the map no matter what
    const { tab } = useContext(InterfaceContext);
    const t = tabs.find((tc) => tc.id === tab.slug);
    return (
        <>
            <div id="tab-content" className={'use-' + t.id} role="tabpanel">
                <AppDownloader>
                    <DownloadModal />
                    <DownloadModalBackground />

                    <section id={'panel-map'} className={'tabpanel' + (t.id === 'map' ? ' active' : '')}>
                        <ContentMap />
                    </section>
                    {t.id === 'data' && (
                        <section id={'panel-data'} className={'tabpanel active'}>
                            <ContentData />
                        </section>
                    )}
                    {t.id === 'info' && (
                        <section id={'panel-info'} className={'tabpanel active'}>
                            <ContentInformation />
                        </section>
                    )}
                </AppDownloader>
            </div>
        </>
    );
};

export default memo(TabsContent);
